import React, { useEffect, useState } from "react";
import { coldwavecardsdata } from "../../../../Services/EndPoints";
import { getData } from "../../../../Services/ProfileServices";
import "./ColdwaveDashboard.css";

const PALETTE = [
  { bg: "#FFF0F0", color: "#D95555" },
  { bg: "#FFF4EA", color: "#D4772A" },
  { bg: "#EEFAF3", color: "#27A05A" },
  { bg: "#EBF4FF", color: "#3579D4" },
  { bg: "#F3EEFF", color: "#8B52D6" },
  { bg: "#E7FAFB", color: "#1EA6B4" },
  { bg: "#FFFAEB", color: "#C49A17" },
  { bg: "#FEF0F9", color: "#C93E9F" },
];

function Icon({ keyName = "", label = "", color = "#2A6591" }) {
  const k = (keyName + " " + label).toLowerCase();
  const sw = "1.55";
  const r = "round";

  if (k.includes("loss") || k.includes("death") || k.includes("fatal"))
    return (
      <svg viewBox="0 0 20 20" fill="none" width="17" height="17">
        <circle cx="10" cy="6.5" r="2.8" stroke={color} strokeWidth={sw}/>
        <path d="M4.5 18c0-3.038 2.462-5.5 5.5-5.5s5.5 2.462 5.5 5.5" stroke={color} strokeWidth={sw} strokeLinecap={r}/>
        <path d="M7.8 5l4.4 4.4M12.2 5l-4.4 4.4" stroke={color} strokeWidth="1.4" strokeLinecap={r}/>
      </svg>
    );
  if (k.includes("injur") || k.includes("hospital") || k.includes("medic"))
    return (
      <svg viewBox="0 0 20 20" fill="none" width="17" height="17">
        <rect x="3" y="3" width="14" height="14" rx="4" stroke={color} strokeWidth={sw}/>
        <path d="M10 7v6M7 10h6" stroke={color} strokeWidth="1.8" strokeLinecap={r}/>
      </svg>
    );
  if (k.includes("shelter") || k.includes("night"))
    return (
      <svg viewBox="0 0 20 20" fill="none" width="17" height="17">
        <path d="M2.5 10L10 3.5l7.5 6.5" stroke={color} strokeWidth={sw} strokeLinecap={r} strokeLinejoin={r}/>
        <path d="M4.5 9V17h11V9" stroke={color} strokeWidth={sw} strokeLinejoin={r}/>
        <rect x="8" y="12" width="4" height="5" rx="1" stroke={color} strokeWidth="1.3"/>
      </svg>
    );
  if (k.includes("bonfire") || k.includes("fire") || k.includes("flame"))
    return (
      <svg viewBox="0 0 20 20" fill="none" width="17" height="17">
        <path d="M10 17.5c-4 0-6-3-4.5-7.5.5 2.5 2 3 2 3S6 9.5 9 6c-.5 3.5 2.5 4.5 2.5 4.5S14 8.5 12.5 5c3.5 3 3.5 8.5 1 10.5.5-2-1-3.5-1-3.5C13 14.5 10 17.5 10 17.5z"
          stroke={color} strokeWidth={sw} strokeLinejoin={r}/>
      </svg>
    );
  if (k.includes("blanket") || k.includes("distribut"))
    return (
      <svg viewBox="0 0 20 20" fill="none" width="17" height="17">
        <rect x="3" y="5" width="14" height="11" rx="3" stroke={color} strokeWidth={sw}/>
        <path d="M7 5V4a3 3 0 016 0v1" stroke={color} strokeWidth={sw} strokeLinecap={r}/>
        <path d="M10 9v4M8 11h4" stroke={color} strokeWidth="1.4" strokeLinecap={r}/>
      </svg>
    );
  if (k.includes("people") || k.includes("person") || k.includes("population"))
    return (
      <svg viewBox="0 0 20 20" fill="none" width="17" height="17">
        <circle cx="7" cy="6" r="2.2" stroke={color} strokeWidth={sw}/>
        <path d="M2.5 17c0-2.485 2.015-4.5 4.5-4.5" stroke={color} strokeWidth={sw} strokeLinecap={r}/>
        <circle cx="13" cy="6" r="2.2" stroke={color} strokeWidth={sw}/>
        <path d="M17.5 17c0-2.485-2.015-4.5-4.5-4.5" stroke={color} strokeWidth={sw} strokeLinecap={r}/>
      </svg>
    );
  return (
    <svg viewBox="0 0 20 20" fill="none" width="17" height="17">
      <path d="M10 2.5L3.5 5v5.5c0 4 2.9 6.5 6.5 7 3.6-.5 6.5-3 6.5-7V5L10 2.5z"
        stroke={color} strokeWidth={sw} strokeLinejoin={r}/>
      <path d="M10 8.5v3M10 13v.5" stroke={color} strokeWidth="1.5" strokeLinecap={r}/>
    </svg>
  );
}

export default function ColdWaveDashboardcard({
  config, onIncidentSelect, selectedIncident,
  startDateStr, endDateStr, cardData: parentCardData,
}) {
  // Use parent-supplied data if available, else fetch independently
  const [localCardData, setLocalCardData] = useState({});

  const fetchColdWaveCardData = async () => {
    try {
      const res = await getData(
        coldwavecardsdata
          .replace("FROMDATE", startDateStr)
          .replace("TODATE", endDateStr)
      );
      setLocalCardData(res[0] || {});
    } catch (e) { console.error("Error fetching cold wave card data:", e); }
  };

  useEffect(() => {
    if (!parentCardData && startDateStr && endDateStr) fetchColdWaveCardData();
  }, [startDateStr, endDateStr, parentCardData]);

  const cardData = parentCardData || localCardData;

  const formatValue = (value) => {
    if (typeof value === "string") {
      const parts = value.split("(");
      return <>{parts[0]}{parts[1] && <><br/>({parts[1]}</>}</>;
    }
    return value ?? 0;
  };

  return (
    <div className="cwd-cards-row">
      <div className="cwd-cards-inner">
        {config?.data.map((conf, idx) => {
          const p = PALETTE[idx % PALETTE.length];
          const active = selectedIncident === conf.key;
          return (
            <div
              key={conf.key || idx}
              className={`cwd-card-item${active ? " cwd-card-item--active" : ""}`}
              onClick={() => onIncidentSelect?.(conf.key)}
            >
              <span className="cwd-card-icon" style={{ background: p.bg }}>
                <Icon keyName={conf.key} label={conf.label} color={p.color} />
              </span>
              <span className="cwd-card-label">{conf.label}</span>
              <span className="cwd-card-value">{formatValue(cardData[conf.key])}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}